"use client";

import * as m from "motion/react-m";
import { Button } from "@ui/components/core/Button";
import { useTranslations } from "next-intl";

interface ResumePromptProps {
  onContinue: () => void;
  onStartFresh: () => void;
}

export function ResumePrompt({ onContinue, onStartFresh }: ResumePromptProps) {
  const t = useTranslations("ClientKeys.contact_sales_page.form");

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='tw-mt-8 tw-rounded-xl tw-border tw-bg-cream tw-p-4'
    >
      <div className='tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-4'>
        <p className='tw-text-sm tw-text-black'>{t("resume_prompt.message")}</p>
        <div className='tw-flex tw-gap-3 tw-shrink-0'>
          <Button type='button' onClick={onContinue} variant='primary' size='sm'>
            {t("resume_prompt.continue_button")}
          </Button>
          <Button type='button' onClick={onStartFresh} variant='outline' size='sm'>
            {t("resume_prompt.start_fresh_button")}
          </Button>
        </div>
      </div>
    </m.div>
  );
}
